export const isJson = (value: any) => {
    if (value) {
        try {
            const val = JSON.parse(value);
            return val && val.constructor === Object;
        } catch (error) {
            return false;
        }
    }
    return false;
};

export const pareJson: any = (value: any) => {
    try {
        const val = JSON.parse(value);
        return val;
    } catch (error) {
        return "";
    }
}

export const parseObjectList: any = (value: any) =>{
    try {
        const val = JSON.parse(value);
        return val;
    } catch (e) {
        return [];
    }
}
